module.exports = __webpack_public_path__ + "img/hcml_gallery7.79b5bf27.jpg";